import React from "react";

export type SelectOption = { value: string; label: string };

/**
 * Селект DS (canon-session 2026-07-24): mono-label сверху, нативный select
 * в токен-стиле поля.
 */
export function Select({
  label,
  options,
  error,
  className = "",
  ...rest
}: React.SelectHTMLAttributes<HTMLSelectElement> & {
  label?: string;
  options: SelectOption[];
  error?: string;
}) {
  const borderCls = error
    ? "border-bad focus:border-bad"
    : "border-border focus:border-accent-hover";
  return (
    <label className="flex flex-col gap-1.5">
      {label && (
        <span className="font-mono text-[10.5px] tracking-[0.1em] uppercase text-text-tertiary">
          {label}
        </span>
      )}
      <select
        {...rest}
        // disabled:* обязателен: UA-стиль нативного select перекрывает
        // фон/цвет токенами браузера — поле выпадало в чужую светло-серую
        // палитру. Input этой проблемы не имеет, поэтому расхождение было
        // видно только рядом на одном листе.
        className={`bg-bg-card text-text-primary border ${borderCls} rounded-xl px-3.5 py-[11px] text-sm outline-none transition-colors disabled:bg-bg-card disabled:text-text-tertiary disabled:opacity-60 disabled:cursor-not-allowed ${className}`}
      >
        {options.map((o) => (
          <option key={o.value} value={o.value}>
            {o.label}
          </option>
        ))}
      </select>
      {error && <span className="text-[11.5px] text-bad">{error}</span>}
    </label>
  );
}
